import jQuery from "jquery";

// Must run before plugins that register themselves on the global jQuery.
window.jQuery = window.jQuery || jQuery;
window.$ = window.$ || jQuery;

export default jQuery;
